import type { Component } from 'vue';

import FileIcon from './FileIcon.vue';

export default new Map<string, Component>([
  ['FileIcon', FileIcon]
]);